/**
 * Component Name: FPO
 *
 * Description:
 * The FPO (For Position Only) component renders a transparent overlay with a customizable angled message, often used for placeholder content during development.
 *
 * Usage:
 * Use FPO within a parent element to indicate placeholder content. Pass the `message` prop to customize the displayed text, which defaults to "FPO."
 *
 * Props:
 * - `message` (optional): Text displayed on the overlay. Defaults to "FPO."
 *
 * Notes:
 * - Designed for development purposes only.
 * - The overlay scales with its parent element and does not obstruct interactivity.
 * - The message is angled at 45 degrees and partially transparent for subtlety.
 */

import React, { useEffect } from 'react';
import { resizeFont } from './FPO.logic';
import './FPO.styles.scss';

const FPO: React.FC = () => {
  useEffect(() => {
    // Call the resize logic after the component is rendered
    resizeFont();
    window.addEventListener('resize', resizeFont);

    return () => {
      // Cleanup the event listener on component unmount
      window.removeEventListener('resize', resizeFont);
    };
  }, []);

  return (
    <div className="fpo-overlay">
      <span className="fpo-message">FPO</span>
    </div>
  );
};

export default FPO;
